import { useRef } from 'react';
import { REMOTE_MESSAGE_ACTIONS } from '../../calling-remote/constants/remoteMessageActions';
import { getDndMessageHandler, useDndMessageHandler } from '../../common/hooks/useDndMessageHandler';
import { componentIds } from '../../common/constants/DndComponent';
function getWidgetBoundary(componentName) {
  const widgetIframe = window.document.getElementById(componentIds[componentName]);
  if (!widgetIframe) {
    return {};
  }
  const widgetRect = widgetIframe.getBoundingClientRect();
  return {
    widgetIframe,
    widgetRect
  };
}

/**
 * @param {ComponentName} - This is used to validate the message's origin component
 */
export const useDndWidget = componentName => {
  const handleMessageRef = useRef(() => void 0);
  const removeEventListeners = () => {
    window.removeEventListener('message', handleMessageRef.current);
    window.removeEventListener('mouseup', removeEventListeners);
  };
  function startDragging({
    baseMouseX,
    baseMouseY
  }) {
    if (Number.isNaN(+baseMouseX) || Number.isNaN(+baseMouseY)) {
      return;
    }
    const {
      widgetIframe,
      widgetRect
    } = getWidgetBoundary(componentName);
    if (!widgetIframe) {
      return;
    }
    let frameTop = widgetRect.top;
    let frameLeft = widgetRect.left;
    const clientHeight = document.documentElement.clientHeight;
    const clientWidth = document.documentElement.clientWidth;
    function handleFrameMousemove({
      offsetX,
      offsetY
    }) {
      const {
        widgetIframe: currentWidget,
        widgetRect: currentRect
      } = getWidgetBoundary(componentName);
      if (!currentWidget) {
        return;
      }
      const padding = 16;
      const nextFrameTop = frameTop + offsetY;
      const nextFrameLeft = frameLeft + offsetX;
      frameLeft = Math.max(nextFrameLeft, padding); // limit left
      frameTop = Math.max(nextFrameTop, padding); // limit top

      if (frameLeft + currentRect.width > clientWidth // limit right
      ) {
        frameLeft = clientWidth - currentRect.width - padding;
      }
      if (nextFrameTop + currentRect.height > clientHeight // limit bottom
      ) {
        frameTop = clientHeight - currentRect.height - padding;
      }
      currentWidget.style.left = `${frameLeft}px`;
      currentWidget.style.top = `${frameTop}px`;
    }
    handleMessageRef.current = getDndMessageHandler((action, payload) => {
      if (action === REMOTE_MESSAGE_ACTIONS.MOVING_WIDGET) {
        handleFrameMousemove(payload);
      }
      if (action === REMOTE_MESSAGE_ACTIONS.STOP_DRAGGING) {
        removeEventListeners();
      }
    }, componentName);
    window.addEventListener('message', handleMessageRef.current);
    window.addEventListener('mouseup', removeEventListeners);
  }
  useDndMessageHandler((action, payload) => {
    if (action === REMOTE_MESSAGE_ACTIONS.START_DRAGGING) {
      startDragging(payload);
    }
  }, componentName);
};